<template>
<v-layout style="gap: 10px">
  <v-flex xs12 md8>
    <base-card :title="$t('overviewReport.overview')" class="grow-1">
      <template slot="action">
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn icon @click="onExcelDownload" v-on="on">
              <img width="20" height="20" src="@/assets/icons/excel.png"/>
            </v-btn>
          </template>
          <span>{{$t('exportExcel')}}</span>
        </v-tooltip>
      </template>
      <template slot="content">
        <v-data-table :items="overviewItems" :rows-per-page-items="[20]">
          <template v-slot:headers>
            <tr>
              <td
                  v-for="header in overviewHeaders"
                  :key="header.text">
                <b>{{header.text}}</b>
              </td>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr>
              <td v-for="header of overviewHeaders" :key="header.value">
                <span>{{props.item[header.value]}}</span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </base-card>
  </v-flex>
  <v-flex xs12 md4>
    <base-card :title="$t('overviewReport.agentStatus')" class="grow-2">
      <template slot="content">
        <v-data-table :items="agentStatusItems" :rows-per-page-items="[20]">
          <template v-slot:headers>
            <tr style="display: none">
            </tr>
          </template>
          <template v-slot:items="props">
            <tr>
              <td v-for="header of agentStatusHeaders" :key="header.value">
                <span>{{props.item[header.value]}}</span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </base-card>
  </v-flex>
</v-layout>
</template>

<script>
import BaseCard from "components/BaseCard";
import {mapState} from "vuex";
import * as excelJS from "exceljs";
import { saveAs } from "file-saver";
function toPercent(value, total) {
  return (total > 0 ? (value/total) * 100 : 0).toFixed() + ' %'
}
export default {
  name: "OverviewReportDetails",
  components: {BaseCard},
  computed: {
    ...mapState('overviewReport', ['overviewReport', 'autoAssignStatusManage', 'filter']),
    overviewHeaders() {
      return [
        {
          text: '',
          value: 'text'
        },
        {
          text: 'No.',
          value: 'no',
        },
      ]
    },
    agentStatusHeaders() {
      return [
        {
          text: '',
          value: 'text'
        },
        {
          text: '',
          value: 'value'
        }
      ]
    },
    agentStatusItems() {
      let countAgentActivate = 0;
      let countAgentDeactivate = 0;
      if (this.autoAssignStatusManage) {
        let isEnableAutoAssign = this.autoAssignStatusManage.enable_auto_assign;
        let supporters = this.autoAssignStatusManage.supporters;
        if (isEnableAutoAssign === "0") {
          countAgentActivate = 0;
          countAgentDeactivate = supporters.length;
        } else {
          countAgentActivate = supporters.filter(supporter => {
            return supporter.auto_assign_config.active && this.filter.skills.every(v => supporter.auto_assign_config.request_support_categories.includes(v));
          }).length;
          countAgentDeactivate = supporters.length - countAgentActivate
        }
      }
      return [
        {
          text: this.$t('overviewReport.agentActivate'),
          value: countAgentActivate
        },
        {
          text: this.$t('overviewReport.agentDeactivate'),
          value: countAgentDeactivate
        }
      ]
    },
    overviewItems() {
      if (!this.overviewReport) {
        return []
      }
      const totalSession = this.overviewReport.total_chat;
      const totalSLAAfter5m = totalSession - this.overviewReport.earlier_five_minute
      return [
        {
          text: this.$t('overviewReport.totalServed'),
          no: this.overviewReport.total_served,
        },
        {
          text: this.$t('overviewReport.totalWaiting'),
          no: this.overviewReport.total_waiting,
        },
        {
          text: this.$t('overviewReport.totalForward'),
          no: this.overviewReport.total_forward,
        },
        {
          text: this.$t('overviewReport.totalReceiveRequestSupport'),
          no: this.overviewReport.total_mark_new_request,
        },
        {
          text: this.$t('overviewReport.totalEarlierTenSeconds'),
          no: this.overviewReport.earlier_ten_seconds,
        },
        {
          text: this.$t('overviewReport.totalEarlierThirtySeconds'),
          no: this.overviewReport.earlier_thirty_seconds,
        },
        {
          text: this.$t('overviewReport.totalEarlierFortyFiveSeconds'),
          no: this.overviewReport.earlier_forty_five_seconds,
        },
        {
          text: this.$t('overviewReport.totalEarlierOneMinute'),
          no: this.overviewReport.earlier_one_minute,
        },
        {
          text: this.$t('overviewReport.totalEarlierFiveMinute'),
          no: this.overviewReport.earlier_five_minute,
        },
        {
          text: this.$t('overviewReport.totalAfterFiveMinute'),
          no: totalSLAAfter5m,
        },
        {
          text: this.$t('overviewReport.totalChat'),
          no: this.overviewReport.total_chat,
        },
      ]
    }
  },
  methods: {
    onExcelDownload() {
      const workbook = new excelJS.Workbook();
      workbook.created = new Date();
      workbook.modified = new Date();

      let sheet = workbook.addWorksheet("Report");
      sheet.getRow(1).values = ["", "No.","%"];
      sheet.columns = [
        { key: "text", width: 100, alignment: {horizontal: "left"} },
        { key: "no", width: 30 },
        { key: "percent", width: 30 },
      ];
      const totalSession = this.overviewReport.total_chat;
      const totalSLAAfter5m = totalSession - this.overviewReport.earlier_five_minute
      const data = [
        {
          text: this.$t('overviewReport.totalServed'),
          no: this.overviewReport.total_served,
          percent: '-'
        },
        {
          text: this.$t('overviewReport.totalWaiting'),
          no: this.overviewReport.total_waiting,
          percent: '-'
        },
        {
          text: this.$t('overviewReport.totalForward'),
          no: this.overviewReport.total_forward,
          percent: '-'
        },
        {
          text: this.$t('overviewReport.totalReceiveRequestSupport'),
          no: this.overviewReport.total_mark_new_request,
          percent: '-'
        },
        {
          text: this.$t('overviewReport.totalEarlierTenSeconds'),
          no: this.overviewReport.earlier_ten_seconds,
          percent: toPercent(this.overviewReport.earlier_ten_seconds, totalSession)
        },
        {
          text: this.$t('overviewReport.totalEarlierThirtySeconds'),
          no: this.overviewReport.earlier_thirty_seconds,
          percent: toPercent(this.overviewReport.earlier_thirty_seconds, totalSession)
        },
        {
          text: this.$t('overviewReport.totalEarlierFortyFiveSeconds'),
          no: this.overviewReport.earlier_forty_five_seconds,
          percent: toPercent(this.overviewReport.earlier_forty_five_seconds, totalSession)
        },
        {
          text: this.$t('overviewReport.totalEarlierOneMinute'),
          no: this.overviewReport.earlier_one_minute,
          percent: toPercent(this.overviewReport.earlier_one_minute, totalSession)
        },
        {
          text: this.$t('overviewReport.totalEarlierFiveMinute'),
          no: this.overviewReport.earlier_five_minute,
          percent: toPercent(this.overviewReport.earlier_five_minute, totalSession)
        },
        {
          text: this.$t('overviewReport.totalAfterFiveMinute'),
          no: totalSLAAfter5m,
          percent: toPercent(totalSLAAfter5m, totalSession)
        },
        {
          text: this.$t('overviewReport.totalChat'),
          no: this.overviewReport.total_chat,
          percent: toPercent(this.overviewReport.total_chat, totalSession)
        },
      ]
      sheet.addRows(data);

      const row = sheet.getRow(1);
      row.eachCell((cell, rowNumber) => {
        sheet.getColumn(rowNumber).alignment = {
          vertical: "middle",
        };
        sheet.getColumn(rowNumber).font = { size: 14, family: 2 };
      });

      workbook.xlsx.writeBuffer().then(function(buffer) {
        const blob = new Blob([buffer], { type: "application/xlsx" });
        saveAs(blob, "Overview Report.xlsx");
      });
    }
  }
}
</script>

<style scoped>

</style>